import {createModal} from "./Modal";
import _ from './language';

window.openTitleAsModal = function (event) {
    let element = document.createElement('div');
    element.innerText = event.target.getAttribute('title');

    createModal(_('info'), element);
};
